import {
    Component, Prop, Mixins,
} from 'vue-property-decorator';
import CommonProps from '@components/shared/mixins/props';

/**
 * Breadcrumb Props
 */
@Component
class Props extends Mixins(CommonProps) {
    /**
     * Items of the breadcrumb
     *
     * @example
     * [
     *     {
     *          title: '',
     *          icon: '',
     *          route: {
     *              name: '',
     *              params: {},
     *              query: {},
     *          }
     *     }
     * ]
     */
    @Prop({ type: [Array, Object], required: true }) items!: Array<Record<string, unknown>>;
    
    /**
     * Add background color to breadcrumb
     */
    @Prop({ type: Boolean }) hasBg!: boolean;

    /**
     * Add background color to breadcrumbs item
     */
    @Prop({ type: Boolean }) linkBg!: boolean;

    /**
     * Set responsive mode
     */
    // TODO - Commented for declear prop error
    // @Prop({ type: Boolean, default: false }) responsive!: boolean;

    /**
     * Set last item count to show
     */
    @Prop({ type: [Number, String], default: '1' }) lastItems!: number | string;

    /**
     * Breadcrumb Divider
     */
    @Prop({ type: String, default: 'slash' }) divider!: boolean;

    /**
     * Base language
     */
    @Prop({ type: String, default: 'fa' }) lang!: string;

    /**
     * Icons library code name. here's a list of supported icons libraries:
     * 'mdi' - Material Design Icons - https://materialdesignicons.com/
     * 'fa' - Font Awesome - https://fontawesome.com/icons
     */
    @Prop({ type: String, default: 'fa' }) library!: string;

    /**
     * Prefix of the icon
     * Font Awesome prefix: 'fab', 'far', 'fas'.
     */
    @Prop({ type: String, default: 'fas' }) prefix!: string
}

export default Props;
